import {Scheme, SchemeFile, SchemeProduct, SchemeTechnicalCharacteristics, SchemeStatus} from '../domain/scheme.model';
import {SchemeDto, SchemeFilesDto, SchemeProductsDto, SchemeTechnicalCharacteristicsDto} from './scheme.dto';

const mapSchemeFile = (dto: SchemeFilesDto): SchemeFile => {
  return {
    url: dto.url,
    type: dto.type
  };
}

const mapSchemeProduct = (dto: SchemeProductsDto): SchemeProduct => {
  return {
    area: dto.area,
    group: dto.group,
    name: dto.name
  };
}

const mapSchemeTechnicalCharacteristics = (dto: SchemeTechnicalCharacteristicsDto): SchemeTechnicalCharacteristics => {
  return {
    cylinders: dto.cylinders ?? [],
    circles: dto.circles ?? [],
    coolings: dto.coolings ?? [],
    systemComponents: dto.systemComponents ?? [],
    hmis: dto.hmis ?? [],
    others: dto.others ?? [],
    exclusions: dto.exclusions ?? []
  };
}

export const mapScheme = (dto: SchemeDto): Scheme => {
  return {
    id: dto.id,
    schematicId: dto.schematicId,
    version: dto.version,
    validFrom: dto.validFrom ? new Date(dto.validFrom) : undefined,
    status: dto.status as SchemeStatus,
    access: dto.access,
    name: dto.name!,
    description: dto.description,
    history: dto.history,
    language: dto.language,
    country: dto.country,
    files: dto.files.map(mapSchemeFile),
    products: dto.products.map(mapSchemeProduct),
    productsCascade: dto.productsCascade.map(mapSchemeProduct),
    technicalCharacteristics: mapSchemeTechnicalCharacteristics(dto.technicalCharacteristics ?? {})
  };
}
